var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.55556 10C6.00327 10 5.55556 10.4477 5.55556 11C5.55556 11.5523 6.00327 12 6.55556 12V10ZM15.4444 12C15.9967 12 16.4444 11.5523 16.4444 11C16.4444 10.4477 15.9967 10 15.4444 10V12ZM10 15.4444C10 15.9967 10.4477 16.4444 11 16.4444C11.5523 16.4444 12 15.9967 12 15.4444H10ZM12 6.55556C12 6.00327 11.5523 5.55556 11 5.55556C10.4477 5.55556 10 6.00327 10 6.55556H12ZM11 20C6.02944 20 2 15.9706 2 11H0C0 17.0751 4.92487 22 11 22V20ZM2 11C2 6.02944 6.02944 2 11 2V0C4.92487 0 0 4.92487 0 11H2ZM11 2C15.9706 2 20 6.02944 20 11H22C22 4.92487 17.0751 0 11 0V2ZM20 11C20 15.9706 15.9706 20 11 20V22C17.0751 22 22 17.0751 22 11H20ZM6.55556 12H15.4444V10H6.55556V12ZM12 15.4444V6.55556H10V15.4444H12Z",
    fill: "#B0BCC1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusDisabled);
export default __webpack_public_path__ + "static/media/plus_disabled.506501b3011ade7e45ec5576e066c0a1.svg";
export { ForwardRef as ReactComponent };